module.exports = __webpack_public_path__ + "img/slide_title_sp.529b8a3a.svg";